import React from 'react'
import { useContext } from 'react';
import { GlobalState } from '../../GlobalState';
import { useEffect } from 'react';
import { api } from '../../util/urlConfig';
import moment from 'moment';
import { useState } from 'react';
import axios from '../../helpers/axios';

export default function PurchaseNotifyComponent({ purchaseId }) {
  const [purchaseDetail, setPurchaseDetail] = useState(null);

  const getPurchaseDetail = async (purchaseId) => {
    const res = await axios.get(`/purchase/${purchaseId}`);
    setPurchaseDetail(res.data.response.data);
  }

  useEffect(() => {
    getPurchaseDetail(purchaseId);
  }, [purchaseId])

  return (
    <>
      {
        purchaseDetail ?
          <div className='notify-main-container'>
            <div className='notify-content-area'>
              <img className='notify-img' src={purchaseDetail.supplier && purchaseDetail.supplier.upload_image ? api + "/" + purchaseDetail.supplier.upload_image.image_url : "/img/dummy_avatar.png"} alt="avatar" />
              <div className='notify-content-detail'>
                <div className='notify-name'>
                  {
                    purchaseDetail.supplier ? purchaseDetail.supplier.first_name + " " + purchaseDetail.supplier.last_name
                      : purchaseDetail.created_by ? purchaseDetail.created_by.first_name + " " + purchaseDetail.created_by.last_name : ""
                  }
                </div>


                <div className='notify-subname'>You have purchased for Rs. {purchaseDetail.total_amount}</div>
                <div className='notify-subname'>
                  <i className='uil uil-clock'></i>
                  <span>{moment(purchaseDetail.created_at).format('DD-MM-YYYY')}</span>
                </div>
              </div>
            </div>
          </div>
          : <></>
      }
    </>
  )
}
